import ky, { type KyInstance } from 'ky';

export { HTTPError } from 'ky';

type QueryObject = Record<
	string,
	| string
	| number
	| boolean
	| null
	| undefined
	| Array<string | number | boolean | null | undefined>
>;

declare module 'ky' {
	interface Options {
		params?: QueryObject;
	}
}

export let api: KyInstance = new Proxy({} as KyInstance, {
	get() {
		throw new Error('uninitiated api client');
	},
});

let apiUrl = '';

const serialize = (params: QueryObject) => {
	const searchParams = new URLSearchParams();
	for (const [key, value] of Object.entries(params)) {
		if (value == null || value === '') {
			continue;
		}

		if (Array.isArray(value)) {
			for (const item of value) {
				if (item != null && item !== '') {
					searchParams.append(key, String(item));
				}
			}
			continue;
		}

		searchParams.append(key, String(value));
	}
	return searchParams;
};

export const init = (API_URL: string) => {
	apiUrl = API_URL;

	api = ky.extend({
		prefix: API_URL,
		credentials: 'include',
		hooks: {
			init: [
				(options) => {
					if (options.params) {
						options.searchParams = serialize(options.params);
					}
				},
			],
		},
	});
};

export const getApiUrl = () => apiUrl;
